/** Anonymous fixture values used only by the daily schedule's shooting-schedule popup. */
export const legacyShootScheduleTypes = [
  { id: 'l_scheduleTypeGeneral', label: '일반일정' },
  { id: 'l_scheduleTypeWorkDaily', label: '업무일지' },
  { id: 'l_scheduleTypeShootingWait', label: '촬영대기' },
  { id: 'l_scheduleTypeShoot', label: '촬영스케줄' },
]

export const legacyShootScheduleStatus = ['미완료', '완료', '연기', '취소', '변경', '노쇼', '2주', 'OK']
export const legacyShootScheduleColors = [
  '#131814', '#38b9c2', '#2c9100', '#0033ff', '#5e4200',
  '#f0cc62', '#e63774', '#7b4fc7', '#ff8f3d', '#4285f4',
  '#34a853', '#fbbc04', '#ea4335', '#5f6368', '#8ab4f8',
  '#81c995', '#fde293', '#f28b82', '#d7aefb', '#78d9ec',
]
export const legacyShootScheduleCrewLabels = ['촬영자', '모니터실', '메이크업', '연출', '영상', '상담자']
export const legacyShootScheduleTimeRows = Array.from({ length: 66 }, (_, index) => {
  const minutes = 8 * 60 + index * 10
  return `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`
})
